

<form class="mce-form-section">

    <div class="mce-form-section-title">
        Description
        <button matIconButton type="button"
                matTooltip="Issues with the project, please open a ticket quoting reference {{form().uid().value()}}. Click to copy reference to clipboard."
                [cdkCopyToClipboard]="form().uid().value()">
            <mat-icon>chat_info</mat-icon>
        </button>
    </div>

    <div class="mce-form-field-group">

        <div>
            <mat-form-field>
                <mat-label>designation/number</mat-label>
                <input matInput placeholder="enter a cable designation"
                        [formField]="form().designation" />
                @for (error of form().designation().errors(); track error.kind ) {
                <mat-error>  {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        <div>
            <mat-form-field>
                <mat-label>source</mat-label>
                <input matInput placeholder="enter a cable source"
                        [formField]="form().source" />
                @for (error of form().source().errors(); track error.kind ) {
                <mat-error>  {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        <div>
            <mat-form-field>
                <mat-label>destination</mat-label>
                <input matInput placeholder="enter a cable destination"
                        [formField]="form().destination" />
                @for (error of form().destination().errors(); track error.kind ) {
                <mat-error>  {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

    </div>

    <div>
        <mat-form-field class="w-full">
            <mat-label>description</mat-label>
            <input matInput placeholder="enter a cable description"
                    [formField]="form().description" />
            @for (error of form().description().errors(); track error.kind ) {
            <mat-error>  {{ error.message }} </mat-error> }
        </mat-form-field>
    </div>

</form>
